import { VehicleConditionalCardData } from "./blocks";
import { ActionButtonData, ScriptData, ClientSiteData } from "./site";
import { IPageBlock } from "./ui";
import { Vehicle } from "./vehicle";

export enum VDPBlockPosition {
  LEFT = "left",
  RIGHT = "right",
  BOTTOM = "bottom",
}

export interface VDPBlockGlobalInitData {
  actionButtons: ActionButtonData[];
  isSingleColumnRendering: boolean;
  vehicle: Vehicle;
  vehicleCardData?: VehicleConditionalCardData;
}

export interface IVDPPageBlock extends IPageBlock {
  renderingPosition: VDPBlockPosition;
  vdpGlobalData: VDPBlockGlobalInitData;
}

export interface StyleData {
  id: string;
  content: string;
}

export interface VDPBlockPageData {
  siteData: ClientSiteData;
  host: string;
  vehicleCardData: VehicleConditionalCardData;
  styles: StyleData[];
  scripts: ScriptData[];
}

export type VDPComponentServerHook = (config: any, vehicle: Vehicle, pageData: VDPBlockPageData) => Promise<any>;
export type VDPComponentGlobalInitHook = (config: any, vehicle: Vehicle, vdpGlobalData: VDPBlockGlobalInitData) => void;
export type VDPBlockConstructor = (props: IVDPPageBlock, key?: any) => JSX.Element;

export interface IVDPBlockData {
  position: VDPBlockPosition;
  component: VDPBlockConstructor;
}
